module.exports = __webpack_public_path__ + "img/shipment-search.01fd1a9a.svg";